import { combineReducers } from "redux";
import FileUpload from "./FileUpload";
import UserReducer from "./User";
import CustomerReducer from "./Customer";
import AuthReducer from "./Authorisation";
import ModalPopupReducer from "./ModalPopup";
import tree from "./Tree";
import TenantReducer from "./Tenant";
import messageSlice from '@/redux/messageSlice';
import { routerReducer } from 'react-router-redux'
import Notification  from "./Notification";
import InvoiceReducer  from "./Invoice";
import SettingsReducer from "@/reducers/Settings";
import TimeRegistrationReducer from "@/reducers/TimeRegistration";
import RedirectReducer from "@/reducers/redirect";
import NotificationReducer from "./NotificationReducer";
import RolesReducer from "./Roles";
import FilesReducer from "./Files";
import DocumentReducer from "./Document";
import WorkProcessReducer from "./WorkProcess";
import DossierReducer from "./Dossier";
import CommunicationCycleReducer from './CommunicationCycle';
import ProspectReducer from "./Prospect";
import ScheduleReducer from "./Schedule";
import ModalReducerClass from "./ModalReducer";

import AdminUserReducer from "./AdminUser";

import ApplicationReducer from "./ApplicationReducer";
import TranslationReducer from "./Translation";
import WindowReducer from "./Window";
import TimerReducer from "./TimerReducer";
import DB from "@/models/DB";


/*
export default combineReducers({
  auth,message,modalview,loader, menu, messageSlice
});
*/
//const chat = messageSlice.reducer;
const chat = messageSlice.reducer;
const allReducers = combineReducers({
    ApplicationReducer,
    AuthReducer
  ,routing: routerReducer,
  NotificationReducer,
 TimeRegistrationReducer,
  chat
,FileUpload,
//tree,
UserReducer,
CustomerReducer, 
ModalPopupReducer, 
Notification,
  TenantReducer,
  InvoiceReducer,
  SettingsReducer,
  RedirectReducer,  
    RolesReducer,
    FilesReducer,
    DocumentReducer,
    AdminUserReducer,
    WorkProcessReducer,
    DossierReducer,
    CommunicationCycleReducer,
    ProspectReducer,
    ScheduleReducer,
    ModalReducerClass,
    TranslationReducer,
    WindowReducer,
    TimerReducer  
});

export default (state, action) => {
  
  // if(action?.payload?.data?.pagination) {
  //   console.debug("PAGAGAGA", action.payload.data);
  //   let paginationModel = DB.newModel(action.payload.data.pagination, 'PaginationModel ');
  //   console.debug("PAGAGAGA", paginationModel);
  //   action.payload.data.pagination2 = paginationModel;
  //   console.debug("PAGAGAGA", action.payload.data );
  // }
  
  
  if(action?.type == 'chat/receiveMessage') {
    let data = null;
    if(action.payload.event.data) {
      data = JSON.parse(action.payload.event.data);
      action.event = data;    
    }
  }
  
  action.state = state;
  return allReducers(state, action);
}

